import React, { useEffect, useState } from "react";
import {
  FilterButton,
  SearchInput,
  SummaryCardGrid,
  TabButtonGroup,
  Loader,
} from "../components/shared";
import CustomerImformation from "../components/voiceCallComp/CustomerImformation";
import useMediaQuery from "../utils/hooks/useMediaQuery";
import { useOutletContext } from "react-router-dom";
import { useSelectedCustomer } from "../utils/context/SelectedCustomerContext";
import { collection, getDocs } from "firebase/firestore";
import { voiceCallSummary, buttonLabels } from "../utils/data"; // keep this static or fetch if dynamic
import { db } from "../utils/firebase/firebaseConfig";

const VoiceCalls = () => {
  const isMdUp = useMediaQuery("(min-width: 768px)");
  const { toggleSidebar } = useOutletContext();
  const { setSelectedCustomerId } = useSelectedCustomer();

  const [callLogs, setCallLogs] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ Loader state

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(1);

  useEffect(() => {
    const fetchCallLogs = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "customers"));
        const logs = [];

        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();
          if (Array.isArray(data.callLogs)) {
            data.callLogs.forEach((log) => {
              logs.push({
                ...log,
                phone: data.phone,
                caller: data.name,
              });
            });
          }
        });
        setCallLogs(logs);
      } catch (error) {
        console.error("Error fetching call logs:", error);
      } finally {
        setLoading(false); // ✅ Done loading
      }
    };

    fetchCallLogs();
  }, []);

  const filteredLogs = callLogs.filter((log) => {
    const lowerQuery = searchQuery.toLowerCase();
    return (
      log.caller?.toLowerCase().includes(lowerQuery) ||
      log.phone?.toLowerCase().includes(lowerQuery)
    );
  });
  if (loading) {
    return (
      <div className="w-full h-[calc(100vh-100px)] flex items-center justify-center">
        <Loader size={40} color="black" />
      </div>
    );
  }

  return (
    <div className="flex flex-row w-full min-h-[calc(100vh-100px)]">
      <div
        className={`flex flex-col ${
          isMdUp ? "w-4/5" : "w-full"
        } h-auto gap-2 lg:gap-2`}
      >
        <div className="w-full h-auto border-b border-[#0000002B] flex justify-between items-center pb-2">
          <h1 className="text-[13px] font-semibold leading-[100%] text-black font-inter">
            Voice Calls
          </h1>
          <div className="flex flex-row items-center gap-2 md:hidden">
            <button
              onClick={toggleSidebar}
              className="px-3 py-1 text-[10px] font-medium text-black border border-[#0000002B] rounded-md hover:bg-black-700 transition"
            >
              Menu
            </button>
          </div>
        </div>
        <TabButtonGroup
          buttonLabels={buttonLabels}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />
        <SummaryCardGrid data={voiceCallSummary} />

        <div className="flex flex-row items-center justify-between w-full ">
          <SearchInput
            placeholder="Search Customers .."
            value={searchQuery}
            onChange={setSearchQuery}
          />
          <FilterButton onClick={() => console.log("Filter clicked")} />
        </div>

        <div className="flex-1 h-full">
          <div className="flex-1 w-full h-full pr-2">
            <div className="w-full h-full shadow-[4px_4px_47.1px_0px_#00000040] rounded-[10px] px-1 pt-1 overflow-hidden">
              <div className="w-full h-[40px] text-center bg-[#F6F9FF] border border-[#00000029] rounded-[10px] flex items-center px-4">
                {[
                  "Caller Information",
                  "Date",
                  "Duration",
                  "Direction",
                  "Issue",
                  "Status",
                ].map((col, i) => (
                  <div
                    key={i}
                    className="md:text-[12px] text-[11px] font-normal text-black font-inter w-full"
                  >
                    {col}
                  </div>
                ))}
              </div>

              <div className="flex flex-col gap-0 flex-1 mt-2 overflow-y-auto max-h-[380px] 2xl:max-h-[450px] pr-1">
                {filteredLogs.map((row, index) => (
                  <React.Fragment key={index}>
                    <div
                      onClick={() => setSelectedCustomerId(row.phone)}
                      className="w-full cursor-pointer h-[60px] text-center hover:bg-[#F6F9FF] rounded-[12px] flex items-center px-4"
                    >
                      <div className="w-full flex flex-col  md:text-[11px] text-[10px] font-inter">
                        <div className="text-black">{row.caller}</div>
                        <div className="text-black text-opacity-40">
                          {row.phone}
                        </div>
                      </div>
                      <div className="w-full md:text-[11px] text-[10px] font-inter text-opacity-40 text-black">
                        {row.date}
                      </div>
                      <div className="w-full md:text-[11px] text-[10px] font-inter text-opacity-40 text-black">
                        {row.duration}
                      </div>
                      <div className="w-full md:text-[11px] text-[10px] font-inter text-opacity-40 text-black">
                        {row.direction}
                      </div>
                      <div className="w-full md:text-[11px] text-[10px] font-inter text-opacity-40 text-black">
                        {row.issue}
                      </div>
                      <div
                        className="w-full md:text-[11px] text-[10px] font-inter text-opacity-40"
                        style={{ color: row.textColor }}
                      >
                        {row.status}
                      </div>
                    </div>
                    <div className="w-full border-b z-10 border-[#00000029]"></div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar - only on desktop */}
      {isMdUp && <CustomerImformation />}
    </div>
  );
};

export default VoiceCalls;
